import { Injectable } from '@angular/core';
import { EditionCode, FunctionalityGroup } from 'src/app/model/configuration';
import { ConfigurationService } from './configuration.service';
import { CALPrefix, IndustryDescription, IndustryPurchasedInfo, OptionAvailability } from 'src/app/model/industry';
import { Instance, InstSnapVersInfo, SnapshotType } from 'src/app/model/instance';
import { environment } from 'src/environments/environment';
import { OperationResult, TbAuthService } from '@tb/auth';
import { TranslatedVariables } from './../../commons/translated-variables';
import { AlertDialogComponent } from './../../store/dialogs/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WorkFlowService } from './work-flow.service';
import { StoreRolesService } from './store-role.service';
import { ServiceUtilsService } from './service-utils.service';
import { Router } from '@angular/router';
import { LoadingService } from './loading.service';
import { IndustriesPurchasedDetails } from 'src/app/model/IndustriesPurchasedDetails';
import { ModelService } from './model.service';
import { CountryService } from './country.service';
import { ProductService } from './product.service';
import { Feature, OptionInfo } from 'src/app/model/feature';
import { GraphElement } from 'src/app/model/graphElement';
import { MiniStorageService } from './mini-storage.service';
import { InstancesService } from './instances.service';
import { SubscriptionService } from './subscription.service';
import { FragmentStatus } from 'src/app/industryeditor/models/industry-fragment';
import { AppSubscription, Mode } from 'src/app/model/subscription';

@Injectable({
    providedIn: 'root',
})
export class MagoCloudService {
    storeApiUrl: string;
    graphElements: GraphElement[] = [];
    public language: string;
    public industryDictionaryList: IndustryDescription[] = []; //usato nell'html
    public loading: boolean = true;
    public expandSummary: boolean = false;
    public countryValue: string = 'none';
    public functionalitygroupsAlwaysAvalilable: FunctionalityGroup[] = [];
    public currIndustryPurchInfo: IndustryPurchasedInfo = new IndustryPurchasedInfo();
    public currentIndustry: IndustryDescription = new IndustryDescription();
    public edition: string;
    public moduleCode: string = '';
    public version: string = '';
    public isModifyStatus: boolean;
    public subscriptionNfs: boolean;
    public calFullNrMap = new Map<string, number>();
    //snapshot
    public snapShotsList: InstSnapVersInfo[];
    public instanceList: InstSnapVersInfo[] = [];
    public allInstancesList: InstSnapVersInfo[] = [];
    public CALFeature: Feature[] = [];
    public CALCountableFeatureSelected: Feature[] = [];
    public filteredFeatureByCountry: Feature[] = [];
    public selectedOptionInfo: OptionInfo[] = [];
    public functionalitygroupsNoCAL: FunctionalityGroup[] = [];
    public functionalitygroupsCAL: FunctionalityGroup[] = [];
    public isZucchettiDiretta: boolean = false;
    tempGraphElement: GraphElement[] = [];
    public defaultSnapshot: InstSnapVersInfo;
    public countryDescri: string = '';
    public totalCalFullNr: number = 0;
    public currCompanyCode: string;
    public currCompanyName: string;
    public instances: Instance[] = [];
    public isAllowedToChooseMultiInstances: boolean = false;
    public productID: string = '';
    public subTypeSelected: string;
    public instanceKey: string;
    public selectedSnapshotID: string;

    constructor(
        private serviceUtilsService: ServiceUtilsService,
        private storeRoleService: StoreRolesService,
        public workFlow: WorkFlowService,
        private dialog: MatDialog,
        private variable: TranslatedVariables,
        private router: Router,
        public configurationService: ConfigurationService,
        public loadingService: LoadingService,
        private modelService: ModelService,
        public countryService: CountryService,
        private productService: ProductService,
        private miniStorage: MiniStorageService,
        private instanceService: InstancesService,
        private subscriptionService: SubscriptionService,
        private tbAuthService: TbAuthService
    ) {
        this.storeApiUrl = environment.settings.storeApiUrl;
    }

    public async getAlwaysFunctionalityGroups(
        countrySelected: string,
        currIndustryPurchInfo: IndustryPurchasedInfo,
        currentIndustry: IndustryDescription,
        selectedEdition: string,
        industryModuleCode: string,
        version: string
    ) {
        this.countryValue = countrySelected;
        this.currIndustryPurchInfo = currIndustryPurchInfo;
        this.currentIndustry = currentIndustry;
        this.edition = selectedEdition;
        this.moduleCode = industryModuleCode;
        this.version = version;

        this.functionalitygroupsAlwaysAvalilable = await this.configurationService.getAlwaysFunctionalityGroups(
            this.currIndustryPurchInfo.SelectedFeatures,
            true,
            this.edition
        );
    }

    async getInstancesList(subtypeSelected: string, industrCode: string) {
        let result: OperationResult = await this.configurationService.getAllInstances(subtypeSelected, industrCode);
        let data: InstSnapVersInfo[] = result.Content as InstSnapVersInfo[];
        if (data === null || data === undefined) {
            this.instanceList = [];
        }
        this.allInstancesList = data;
        this.instanceList = [];
        data.forEach((element) => {
            if (!this.instanceList.find((x) => x.InstanceKey == element.InstanceKey)) this.instanceList.push(element);
        });
    }
    public getSnapshotFromInstancesList(instanceKey: string) {
        this.snapShotsList = this.allInstancesList.filter((x) => x.InstanceKey === instanceKey);
        this.defaultSnapshot = this.snapShotsList.find((x) => x.SnapshotType === SnapshotType.DEFAULT);
    }

    public async loadInternalIndustryInfo(subscriptionKey: string, accountName: string) {
        //cerco la riga nei details
        let result: OperationResult = await this.modelService.getIndustryPurchasedDetails(accountName, subscriptionKey);
        if (!result.Result) {
            let dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.warningTitle,
                    Message: this.variable.warningCannotProceed + ': ' + result.Content,
                    Result: true,
                    ShowDisableMe: false,
                },
            });
            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                this.router.navigate(['home']);
            });
            return;
        } else {
            let industryPurchasedDetails: IndustriesPurchasedDetails = result.Content as IndustriesPurchasedDetails;
            let industryPurchased: IndustryPurchasedInfo = JSON.parse(industryPurchasedDetails.IndustryPurchased) as IndustryPurchasedInfo;
            this.currIndustryPurchInfo = industryPurchased;
            //se è in modifica qui ci passa al cambio della country
            //quindi va lasciata quella selezionata dalla tendina
            this.countryValue = this.countryValue == 'none' ? industryPurchased.Country : this.countryValue;
            this.countryDescri = await this.serviceUtilsService.getCountryDescription(this.countryValue);
            this.countryService.setCountry(this.countryValue);
            let moduleCode = industryPurchased.ModuleCode;
            let codes: string[] = moduleCode.split('-');
            this.moduleCode = codes.length > 1 ? codes[1] : moduleCode;
            this.version = await this.configurationService.getLatestIndustryVersion(this.moduleCode, industryPurchased.productID);
            this.subTypeSelected = Mode[this.currIndustryPurchInfo.SubscriptionMode];
            this.instanceKey = this.currIndustryPurchInfo.instanceKey;
            this.selectedSnapshotID = this.currIndustryPurchInfo.SnapshotID;
            this.productID = this.currIndustryPurchInfo.productID;
            this.edition = industryPurchased.Edition.EditionCode;
            //this.version = industryPurchased.Version;
            //valorizzo la release di prodotto
            await this.productService.setProductRelease(
                industryPurchased.productID,
                industryPurchased.SubscriptionMode,
                this.countryService.countrySelected,
                industryPurchased.SubscriptionKey,
                industryPurchased.ModuleCode,
                this.storeRoleService.IsInternal ? '1' : '0',
                ''
            );

            await this.loadIndustryStruct(accountName, this.productService.productRelease);
            if (this.isModifyStatus) {
                await this.setOptionalFeatureValues(this.currIndustryPurchInfo, false);
                //this.calculateAmounts(false);
            }
        }
    }
    public async loadGraphElements(accountName: string, productRelease: string) {
        this.graphElements = [];
        let opRes: OperationResult = await this.configurationService.getGraph(
            accountName,
            this.workFlow.getLanguageForCms(),
            this.moduleCode,
            this.version,
            productRelease,
            this.storeRoleService.IsInternal ? '1' : '0',
            this.isModifyStatus ? '1' : '0',
            this.productID
        );
        if (!opRes.Result) return this.graphElements;
        this.graphElements = opRes.Content as GraphElement[];
        return this.graphElements;
    }

    public async loadIndustryStruct(accountName: string, productRelease: string) {
        if (this.graphElements.length == 0) await this.loadGraphElements(accountName, productRelease);
        let opRes: OperationResult = await this.configurationService.getGraph(
            accountName,
            this.workFlow.getLanguageForCms(),
            this.moduleCode,
            this.version,
            productRelease,
            this.storeRoleService.IsInternal ? '1' : '0',
            this.isModifyStatus ? '1' : '0',
            this.productID
        );

        this.miniStorage.set(this.moduleCode, this.graphElements);
        //devo caricare le feature e filtrarle per nazione scelta
        let countryLanguage = this.workFlow.getLanguageForCms();
        let opResult: OperationResult = await this.configurationService.loadIndustrybyModuleCode(
            countryLanguage,
            this.moduleCode,
            this.version,
            accountName,
            productRelease,
            this.storeRoleService.IsInternal ? '1' : '0',
            this.isModifyStatus ? '1' : '0',
            this.productID
        );
        if (!opResult.Result) {
            return;
        }

        this.currentIndustry = opResult.Content as IndustryDescription;
        this.filteredFeatureByCountry = this.configurationService.filterFeatureByCountryAndSelected(
            this.currentIndustry.Features,
            this.countryValue,
            this.moduleCode
        );
        this.filteredFeatureByCountry.forEach((element) => {
            let isAlwaysAvailable = element.Options.findIndex(
                (x) => x.edition.toLowerCase() == this.edition && x.availability.toLowerCase() === OptionAvailability.ALWAYS
            );
            let isCountable =
                element.Options.findIndex(
                    (x) => x.edition.toLowerCase() == this.edition && x.availability.toLowerCase() === OptionAvailability.COUNT
                ) > -1;
            element.IsMandatory = isAlwaysAvailable > -1;
            element.CurrNrOfUser = isCountable ? 0 : 1;
        });

        this.currentIndustry.OptionalFeatures = this.configurationService.getOptionalFeature(this.filteredFeatureByCountry, this.edition);
        let countableFeature = this.removeCALFromCountableFeature(
            this.configurationService.getCountableFeature(this.filteredFeatureByCountry, this.edition)
        );
        this.currentIndustry.CountableFeatures = countableFeature;

        this.currentIndustry.PptFeatures = this.configurationService.getPptFeature(this.filteredFeatureByCountry, this.edition);
        if (this.isModifyStatus) {
            let optionalFeatures = this.currIndustryPurchInfo.OptionalFeatures;
            for (var i = 0; i < optionalFeatures.length; i++) {
                let f = optionalFeatures[i];
                if (!f) continue;
                //
                let feature = this.currentIndustry.Features.find((x) => x.OptionID == f.OptionID);
                if (!feature) continue;

                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = this.edition;
                t.price = 1; //fake price
                t.optionID = feature.OptionID;
                t.fragment = feature.Fragment;
                t.nrOfUser = f.CurrNrOfUser;
                let exists =
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                        (x) => x.fragment.toLowerCase() == t.fragment.toLowerCase() && x.selectedEdition.toLowerCase() == this.edition
                    ) > -1;
                if (!exists) {
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    this.selectedOptionInfo.push(t);
                }
                feature.isChecked = true;
                feature.IsMandatory = f.IsMandatory;
            }

            let countableFeatures = this.currIndustryPurchInfo.CountableFeatures;
            for (var i = 0; i < countableFeatures.length; i++) {
                let f = countableFeatures[i];
                if (!f) continue;

                let feature = this.currentIndustry.CountableFeatures.find((x) => x.OptionID == f.OptionID);
                if (!feature) continue;

                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = this.edition;
                t.price = 1; //fake price
                t.optionID = feature.OptionID;
                t.fragment = feature.Fragment;
                t.nrOfUser = feature.CurrNrOfUser;
                let exists =
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                        (x) => x.fragment.toLowerCase() == t.fragment.toLowerCase() && x.selectedEdition.toLowerCase() == this.edition
                    ) > -1;
                if (!exists) {
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    this.selectedOptionInfo.push(t);
                }
                feature.isChecked = true;
                feature.IsMandatory = f.IsMandatory;
                this.selectedOptionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
            }
            let pptFeatures = this.currIndustryPurchInfo.PptFeatures;
            for (var i = 0; i < pptFeatures.length; i++) {
                let f = pptFeatures[i];
                if (!f) continue;
                let feature = this.currentIndustry.PptFeatures.find((x) => x.OptionID == f.OptionID);
                if (!feature) continue;

                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = this.edition;
                t.price = 1; //fake price
                t.optionID = feature.OptionID;
                t.fragment = feature.Fragment;
                t.nrOfUser = feature.CurrNrOfUser;
                let exists =
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                        (x) => x.fragment.toLowerCase() == t.fragment.toLowerCase() && x.selectedEdition.toLowerCase() == this.edition
                    ) > -1;
                if (!exists) {
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    this.selectedOptionInfo.push(t);
                }
                feature.isChecked = true;
                this.configurationService.selectedOptionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
            }
        } else {
            //devo caricare i gruppi
            await this.loadPurhcInfo(this.filteredFeatureByCountry, productRelease);
        }
        //devo scartare dalle feature countable le cal
        this.functionalitygroupsNoCAL = await this.configurationService.getFunctionalityGroups(
            this.currIndustryPurchInfo.SelectedFeatures,
            this.currentIndustry.OptionalFeatures,
            false,
            this.edition
        );

        this.functionalitygroupsAlwaysAvalilable = await this.configurationService.getAlwaysFunctionalityGroups(
            this.currIndustryPurchInfo.SelectedFeatures,
            true,
            this.edition
        );
    }

    private async setOptionalFeatureValues(industry: IndustryPurchasedInfo, showpopup: boolean) {
        if (industry.OptionalFeatures == null || industry.OptionalFeatures.length == 0) return;

        //recupero i valori delle feature
        let selectedOptionalFeature: Feature[] = [];
        let selectedOptionalFeaturesOptionInfo: OptionInfo[] = [];

        this.currIndustryPurchInfo.OptionalFeatures.forEach((optionalFeature) => {
            let optionIndex = industry.OptionalFeaturesOptionInfo.findIndex(
                (x) => x.optionID == optionalFeature.OptionID && x.selectedEdition == industry.Edition.EditionCode
            );
            if (optionIndex > -1) {
                let feature = selectedOptionalFeature.find((x) => x.OptionID == optionalFeature.OptionID);
                if (!feature) {
                    optionalFeature.isChecked = true;
                    optionalFeature.CurrNrOfUser = industry.OptionalFeaturesOptionInfo[optionIndex].nrOfUser;
                    selectedOptionalFeature.push(optionalFeature);
                    selectedOptionalFeaturesOptionInfo.push(industry.OptionalFeaturesOptionInfo[optionIndex]);
                    //riassegno alla currIndustry
                    let index = this.currentIndustry.OptionalFeatures.findIndex((x) => x.OptionID == optionalFeature.OptionID);
                    if (index > -1) {
                        this.currentIndustry.OptionalFeatures.splice(index, 1, optionalFeature);
                    }
                }
            }
        });

        this.currIndustryPurchInfo.CountableFeatures.forEach((optionalFeature) => {
            let optionIndex = industry.OptionalFeaturesOptionInfo.findIndex(
                (x) => x.optionID == optionalFeature.OptionID && x.selectedEdition == industry.Edition.EditionCode
            );
            if (optionIndex > -1) {
                let feature = selectedOptionalFeature.find((x) => x.OptionID == optionalFeature.OptionID);
                if (!feature) {
                    optionalFeature.isChecked = true;
                    optionalFeature.CurrNrOfUser = industry.OptionalFeaturesOptionInfo[optionIndex].nrOfUser;
                    selectedOptionalFeature.push(optionalFeature);
                    selectedOptionalFeaturesOptionInfo.push(industry.OptionalFeaturesOptionInfo[optionIndex]);
                    //riassegno alla currIndustry
                    let index = this.currentIndustry.CountableFeatures.findIndex((x) => x.OptionID == optionalFeature.OptionID);
                    if (index > -1) {
                        this.currentIndustry.CountableFeatures.splice(index, 1, optionalFeature);
                    }
                }
            }
        });

        selectedOptionalFeature.forEach((f) => {
            let fOption = f.Options.find((x) => x.edition.toLowerCase() == industry.Edition.EditionCode.toLowerCase());
            if (fOption) {
                if (fOption.availability == OptionAvailability.COUNT) {
                    this.manageOptionInfo(f);
                    this.managePrerequisitesOrIncompatibilities(f, showpopup);
                }
            }
            this.functionalitygroupsNoCAL.forEach((group) => {
                let optFeature: Feature = group.Features.find(
                    (x) =>
                        x.Fragment.toLowerCase() == f.Fragment.toLowerCase() &&
                        (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut || x.Status == FragmentStatus.Planned)
                );
                if (optFeature) {
                    optFeature.isChecked = true;
                    optFeature.SelectedByUser = f.SelectedByUser;
                    this.manageOptionInfo(optFeature);
                    this.managePrerequisitesOrIncompatibilities(f, showpopup);
                } else {
                    //cerco nei figli
                    group.Children.forEach((childrenGroup) => {
                        let optFeature: Feature = childrenGroup.Features.find(
                            (x) =>
                                x.Fragment.toLowerCase() == f.Fragment.toLowerCase() &&
                                (x.Status == FragmentStatus.Available ||
                                    x.Status == FragmentStatus.PhaseOut ||
                                    x.Status == FragmentStatus.Planned)
                        );
                        if (optFeature) {
                            optFeature.isChecked = true;
                            optFeature.SelectedByUser = f.SelectedByUser;
                            this.manageOptionInfo(optFeature);
                            this.managePrerequisitesOrIncompatibilities(f, showpopup);
                        }
                    });
                }
            });
        });
    }
    managePrerequisitesOrIncompatibilities(optFeature: Feature, showpopup: boolean) {
        if (optFeature.isChecked && optFeature.CurrNrOfUser > 0) {
            //devo andare a recuperare tutte le dipendenze e metterle selezionate e readonly
            this.miniStorage.get(this.moduleCode).subscribe((res) => {
                if (res !== undefined && res.length > 0) {
                    this.graphElements = res;
                    let prerequisites: string[] = [];
                    let incompatibilities: string[] = [];
                    let graphElement = this.graphElements.find((x) => x.Fragment.toLowerCase() == optFeature.Fragment.toLowerCase());
                    if (!graphElement) return;
                    prerequisites = graphElement.Prerequisites;
                    incompatibilities = graphElement.Incompatibilities;
                    //se nelle opzioni selezionate c'è già il prerequisito non ti faccio vedere la popup
                    let allPrerequisiteChecked: boolean = this.checkIfAllPrerequisiteAreChecked(prerequisites);
                    if (showpopup) {
                        if (!allPrerequisiteChecked) this.showDialog(optFeature.Description, prerequisites, incompatibilities);
                        else {
                            let atLeastOneIncompSelected: boolean = this.checkIfOneIncompatibilityIsChecked(incompatibilities);
                            if (atLeastOneIncompSelected) {
                                this.showDialog(optFeature.Description, prerequisites, incompatibilities);
                            }
                        }
                    }
                    //devo selezionare tutte le compatibilità
                    let dontCheckElement: boolean = this.checkIncompatibilities(incompatibilities);
                    if (!dontCheckElement) {
                        this.setPrerequisitesSelected(prerequisites, this.storeRoleService.IsInternal, this.isModifyStatus);
                        this.setHintsForPrerequisites(prerequisites);
                    } else {
                        this.removeChecked(optFeature);
                        this.manageOptionInfo(optFeature);
                    }
                } else {
                    return;
                }
            });
        } else {
            this.miniStorage.get(this.moduleCode).subscribe((res) => {
                if (res !== undefined) {
                    this.graphElements = res;
                    let prerequisites: string[] = [];
                    let index = this.graphElements.findIndex((x) => x.Fragment.toLowerCase() == optFeature.Fragment.toLowerCase());
                    let graphElement = this.graphElements[index];
                    if (!graphElement) return;

                    prerequisites = graphElement.Prerequisites;
                    this.removePrerequisitesSelected(
                        prerequisites,
                        optFeature.IsMandatory,
                        optFeature,
                        this.storeRoleService.IsInternal,
                        this.isModifyStatus
                    );
                } else {
                    return;
                }
            });
        }
    }

    manageOptionInfo(optFeature: Feature) {
        if (optFeature != null) {
            //let price = optFeature.pr;
            // if (elem.type == 'checkbox') {
            if (optFeature.isChecked) {
                //let featurePrice: number = this.getFeaturePrice(this.currentIndustry, optFeature, this.edition.toLowerCase());
                let t: OptionInfo = new OptionInfo();
                t.selectedEdition = this.edition;
                t.price = 0;
                t.optionID = optFeature.OptionID;
                t.fragment = optFeature.Fragment;
                t.nrOfUser = optFeature.CurrNrOfUser;

                let isCountable =
                    optFeature.Options.findIndex(
                        (x) => x.edition.toLowerCase() == this.edition && x.availability.toLowerCase() === OptionAvailability.COUNT
                    ) > -1;
                let isOptional =
                    optFeature.Options.findIndex(
                        (x) =>
                            x.edition.toLowerCase() == this.edition &&
                            (x.availability.toLowerCase() === OptionAvailability.OPTIONAL ||
                                x.availability.toLowerCase() === OptionAvailability.STANDALONE)
                    ) > -1;
                let isPPt =
                    optFeature.Options.findIndex(
                        (x) => x.edition.toLowerCase() == this.edition && x.availability.toLowerCase() === OptionAvailability.PPT
                    ) > -1;

                if (isOptional) {
                    let f = this.currIndustryPurchInfo.OptionalFeatures;
                    let index = f.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == this.edition.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        this.currIndustryPurchInfo.OptionalFeatures.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.OptionalFeatures.splice(index, 1, optFeature);
                    }

                    let optionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
                    index = optionInfo.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (index == -1) {
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.splice(index, 1, t);
                    }
                }
                if (isCountable) {
                    let f = this.currIndustryPurchInfo.CountableFeatures;
                    let index = f.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == this.edition.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        this.currIndustryPurchInfo.CountableFeatures.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.CountableFeatures.splice(index, 1, optFeature);
                    }

                    let optionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
                    index = optionInfo.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (index == -1) {
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.splice(index, 1, t);
                    }
                }
                if (isPPt) {
                    let f = this.currIndustryPurchInfo.PptFeatures;
                    let index = f.findIndex(
                        (x) =>
                            x.OptionID == optFeature.OptionID &&
                            x.Options.findIndex((y) => y.edition.toLowerCase() == this.edition.toLowerCase()) != -1
                    );
                    if (index == -1) {
                        this.currIndustryPurchInfo.PptFeatures.push(optFeature);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.PptFeatures.splice(index, 1, optFeature);
                    }

                    let optionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
                    index = optionInfo.findIndex((x) => x.optionID == optFeature.OptionID);
                    if (index == -1) {
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(t);
                    } else {
                        //potrebbe aver aumentato il numero degli utenti
                        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.splice(index, 1, t);
                    }
                }

                this.configurationService.selectedOptionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
            } else {
                this.removeFromSelectedFeature(optFeature, this.edition);
                this.removeFromSelectedOptionInfo(optFeature, this.edition);
            }
        }
    }
    removeFromSelectedFeature(optFeature: Feature, selectedEdition: string) {
        let f = this.currIndustryPurchInfo.OptionalFeatures;
        let index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            this.currIndustryPurchInfo.OptionalFeatures = f;
            this.configurationService.optFeatureSelected = this.currIndustryPurchInfo.OptionalFeatures;
        }

        f = this.currIndustryPurchInfo.CountableFeatures;
        index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            this.currIndustryPurchInfo.CountableFeatures = f;
            this.configurationService.optCountableFeatureSelected = this.currIndustryPurchInfo.CountableFeatures;
        }
        f = this.currIndustryPurchInfo.PptFeatures;
        index = f.findIndex(
            (x) =>
                x.OptionID == optFeature.OptionID &&
                x.Options.findIndex((y) => y.edition.toLowerCase() == selectedEdition.toLowerCase()) != -1
        );
        if (index != -1) {
            f.splice(index, 1);
            this.currIndustryPurchInfo.PptFeatures = f;
        }
    }

    removeFromSelectedOptionInfo(optFeature: Feature, selectedEdition: string) {
        let t = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
        let i = t.findIndex((x) => x.optionID == optFeature.OptionID && x.selectedEdition.toLowerCase() == selectedEdition.toLowerCase());
        if (i != -1) {
            t.splice(i, 1);
            this.currIndustryPurchInfo.OptionalFeaturesOptionInfo = t;
            this.configurationService.selectedOptionInfo = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo;
        }
    }

    setHintsForPrerequisites(prerequisites: string[]) {
        prerequisites.forEach((element) => {
            let graphElement = this.graphElements.find((x) => x.Fragment.toLowerCase() == element.toLowerCase());
            this.addHint(graphElement);
        });
    }
    addHint(graphElement: GraphElement) {
        let index = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == graphElement.Fragment.toLowerCase());
        let gElem = this.tempGraphElement[index];
        if (!gElem) {
            //aggiungo l'originale
            graphElement.NReferences = 1;
            this.tempGraphElement.push(graphElement);
        } else {
            this.tempGraphElement.splice(index, 1);
            gElem.NReferences = gElem.NReferences + 1;
            this.tempGraphElement.push(gElem);
        }
    }

    removeHint(fragment: string) {
        let index = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == fragment.toLowerCase());
        let gElem = this.tempGraphElement[index];
        if (!gElem) return;
        else {
            this.tempGraphElement.splice(index, 1);
            gElem.NReferences = gElem.NReferences - 1;
            this.tempGraphElement.push(gElem);
        }
    }
    removePrerequisitesSelected(
        prerequisites: string[],
        isAlwaysAvailable: boolean,
        featureDeselected: Feature,
        isTester: boolean,
        isModifyingStatus: boolean
    ) {
        if (isAlwaysAvailable) return;
        let alreadyShown: boolean = false;
        for (let i = 0; i < prerequisites.length; i++) {
            let prerequisite = prerequisites[i];
            //rimuovo quell'elelmento del grafo e aggiorno gli hint
            this.removeHint(prerequisite);
            let y = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase());
            if (y == -1) continue;
            let graphElement = this.tempGraphElement[y];
            if (!graphElement) continue;
            if (graphElement.NReferences >= 0) {
                let fOption = featureDeselected.Options.find(
                    (x) => x.edition.toLowerCase() == this.currIndustryPurchInfo.Edition.EditionCode.toLowerCase()
                );
                if (fOption) {
                    if (fOption.availability == OptionAvailability.COUNT) {
                        if (!alreadyShown) {
                            this.showAlert(featureDeselected.Description, prerequisites);
                            alreadyShown = true;
                        }
                    }
                }
                this.removeHintsRecursive(prerequisite, isTester, isModifyingStatus, graphElement.NReferences);
                if (!alreadyShown) {
                    this.showAlert(featureDeselected.Description, prerequisites);
                    alreadyShown = true;
                }
            }
        }
    }
    removeHintsRecursive(prerequisite: string, isTester: boolean, isModifyingStatus: boolean, nReferences: number) {
        this.functionalitygroupsNoCAL.forEach((group) => {
            let optFeatureMaster: Feature = isTester
                ? group.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                : isModifyingStatus
                ? group.Features.find(
                      (x) =>
                          x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                          (x.Status == FragmentStatus.Available ||
                              x.Status == FragmentStatus.PhaseOut ||
                              x.Status == FragmentStatus.Planned)
                  )
                : group.Features.find(
                      (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                  );
            if (optFeatureMaster) {
                optFeatureMaster.isChecked = nReferences > 0;
                optFeatureMaster.IsMandatory = nReferences > 0;
                if (optFeatureMaster.SelectedByUser) {
                    optFeatureMaster.IsMandatory = false;
                    optFeatureMaster.isChecked = nReferences >= 0;
                } else {
                    optFeatureMaster.SelectedByUser = false;
                }
                this.manageOptionInfo(optFeatureMaster);
                if (this.isModifyStatus) {
                    let prereqPrereq: string[] = optFeatureMaster.Prerequisites.split(',').map((element) => element.trim());
                    for (let i = 0; i < prereqPrereq.length; i++) {
                        let prerequisite = prereqPrereq[i];
                        if (prerequisite === '') continue;
                        this.removeHint(prerequisite);

                        let y = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase());
                        if (y == -1) continue;
                        let graphElement = this.tempGraphElement[y];
                        if (!graphElement) continue;
                        if (graphElement.NReferences >= 0) {
                            this.removeHintsRecursive(prerequisite, isTester, isModifyingStatus, graphElement.NReferences);
                        }
                    }
                }
            } else {
                //cerco nei figli
                group.Children.forEach((childrenGroup) => {
                    let optFeatureMaster: Feature = isTester
                        ? childrenGroup.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                        : isModifyingStatus
                        ? childrenGroup.Features.find(
                              (x) =>
                                  x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                                  (x.Status == FragmentStatus.Available ||
                                      x.Status == FragmentStatus.PhaseOut ||
                                      x.Status == FragmentStatus.Planned)
                          )
                        : childrenGroup.Features.find(
                              (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                          );
                    if (optFeatureMaster) {
                        optFeatureMaster.isChecked = nReferences > 0;
                        optFeatureMaster.IsMandatory = nReferences > 0;
                        if (optFeatureMaster.SelectedByUser) {
                            optFeatureMaster.IsMandatory = false;
                            optFeatureMaster.isChecked = nReferences >= 0;
                        } else {
                            optFeatureMaster.SelectedByUser = false;
                            optFeatureMaster.isChecked = nReferences > 0;
                        }
                        this.manageOptionInfo(optFeatureMaster);
                        if (this.isModifyStatus) {
                            let prereqPrereq: string[] = optFeatureMaster.Prerequisites.split(',').map((element) => element.trim());
                            for (let i = 0; i < prereqPrereq.length; i++) {
                                let prerequisite = prereqPrereq[i];
                                if (prerequisite === '') continue;
                                this.removeHint(prerequisite);
                                let y = this.tempGraphElement.findIndex((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase());
                                if (y == -1) continue;
                                let graphElement = this.tempGraphElement[y];
                                if (!graphElement) continue;
                                if (graphElement.NReferences >= 0) {
                                    this.removeHintsRecursive(prerequisite, isTester, isModifyingStatus, graphElement.NReferences);
                                }
                            }
                        }
                    }
                });
            }
        });
    }

    removeChecked(feature: Feature) {
        if (feature.IsMandatory) return;
        feature.isChecked = false;
        feature.SelectedByUser = false;
        let isCountable =
            feature.Options.findIndex(
                (x) => x.edition.toLowerCase() == this.edition && x.availability.toLowerCase() === OptionAvailability.COUNT
            ) > -1;
        feature.CurrNrOfUser = isCountable ? feature.CurrNrOfUser - 1 : 1;
    }
    setPrerequisitesSelected(prerequisites: string[], isTester: boolean, isModifyingStatus: boolean) {
        prerequisites.forEach((prerequisite) => {
            this.functionalitygroupsNoCAL.forEach((group) => {
                let optFeature: Feature = isTester
                    ? group.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                    : isModifyingStatus
                    ? group.Features.find(
                          (x) =>
                              x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                              (x.Status == FragmentStatus.Available ||
                                  x.Status == FragmentStatus.PhaseOut ||
                                  x.Status == FragmentStatus.Planned)
                      )
                    : group.Features.find(
                          (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                      );

                if (optFeature) {
                    optFeature.isChecked = true;
                    optFeature.IsMandatory = true;
                    if (optFeature.SelectedByUser) return;
                    optFeature.SelectedByUser = false;
                    this.manageOptionInfo(optFeature);
                } else {
                    //cerco nei figli
                    group.Children.forEach((childrenGroup) => {
                        let optFeature: Feature = isTester
                            ? childrenGroup.Features.find((x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase())
                            : isModifyingStatus
                            ? childrenGroup.Features.find(
                                  (x) =>
                                      x.Fragment.toLowerCase() == prerequisite.toLowerCase() &&
                                      (x.Status == FragmentStatus.Available || x.Status == FragmentStatus.PhaseOut)
                              )
                            : childrenGroup.Features.find(
                                  (x) => x.Fragment.toLowerCase() == prerequisite.toLowerCase() && x.Status == FragmentStatus.Available
                              );

                        if (optFeature) {
                            optFeature.isChecked = true;
                            optFeature.IsMandatory = true;
                            if (optFeature.SelectedByUser) return;
                            optFeature.SelectedByUser = false;
                            this.manageOptionInfo(optFeature);
                        }
                    });
                }
            });
        });
    }

    checkIncompatibilities(incompatibilities: string[]) {
        let ok = false;
        for (let i = 0; i < incompatibilities.length; i++) {
            let incompatibility = incompatibilities[i];
            this.functionalitygroupsNoCAL.forEach((group) => {
                let optFeature: Feature = group.Features.find(
                    (x) => x.Fragment.toLowerCase() == incompatibility.toLowerCase() && x.isChecked == true
                );
                if (optFeature) {
                    ok = true;
                    return;
                } else {
                    //cerco nei figli
                    group.Children.forEach((childrenGroup) => {
                        let optFeature: Feature = childrenGroup.Features.find(
                            (x) => x.Fragment.toLowerCase() == incompatibility.toLowerCase() && x.isChecked == true
                        );
                        if (optFeature) {
                            ok = true;
                            return;
                        }
                    });
                }
            });
        }
        return ok;
    }
    showAlert(featureDescription: string, prerequisites: string[]) {
        let popupBody: string = '';
        let prerequisitesList = '';
        for (let i = 0; i < prerequisites.length; i++) {
            let feature = this.filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == prerequisites[i].toLowerCase());
            if (!feature) continue;
            prerequisitesList += feature.Description;
            if (i < prerequisites.length - 1) prerequisitesList += '; ';
        }

        if (this.workFlow.languageIsItalian()) {
            popupBody =
                `ATTENZIONE! E' stato deselezionato il modulo:<b> ${featureDescription} </b> occorre deselezionare anche: <b>` +
                prerequisitesList +
                `</b> a meno che non siano moduli che utilizzate.`;
        } else {
            popupBody =
                `WARNING! <b>${featureDescription} </b> module has been removed from configuration, you have to deselect also the following
                          prerequisites unless you use them :<b> ` +
                prerequisitesList +
                `</b>.`;
        }
        if (popupBody.length > 0) this.workFlow.showMessage(this.variable.popupTitle, popupBody);
    }

    showDialog(featureDescription: string, prerequisites: string[], incompatibilities: string[]) {
        let popupBody: string = '';
        let prerequisitesList = '';
        let filteredFeatureByCountry = this.configurationService.filterFeatureByCountryAndSelected(
            this.currentIndustry.Features,
            this.countryValue,
            this.currentIndustry.ModuleCode
        );

        for (let i = 0; i < prerequisites.length; i++) {
            let feature = filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == prerequisites[i].toLowerCase());
            if (!feature) continue;
            prerequisitesList += feature.Description;
            if (i < prerequisites.length - 1) prerequisitesList += '; ';
        }

        if (this.workFlow.languageIsItalian()) {
            popupBody =
                `Per utilizzare il modulo <b> ${featureDescription}</b> devi acquistare anche: <b> ` +
                prerequisitesList +
                `</b>.<br/> Abbiamo aggiornato la tua configurazione aggiungendo tutte le funzionalità necessarie per lavorare con ${featureDescription}`;
        } else {
            popupBody =
                `The <b> ${featureDescription}</b> module requires also: <b>` +
                prerequisitesList +
                `</b>.<br/> We have updated your configuration by adding all the functionality needed to work with ${featureDescription}`;
        }

        //devo andare a recuperare tutte le incompatibilità ed eventualmente dare un messaggio di errore
        if (incompatibilities.length > 0) {
            if (popupBody.length > 0) popupBody += '<br />';
            let incompatibilitiesList = '';

            for (let i = 0; i < incompatibilities.length; i++) {
                let feature = filteredFeatureByCountry.find((x) => x.Fragment.toLowerCase() == incompatibilities[i].toLowerCase());
                if (!feature) continue;
                incompatibilitiesList += feature.Description;
                if (i < incompatibilities.length - 1) incompatibilitiesList += '; ';
            }

            if (this.workFlow.languageIsItalian()) {
                popupBody +=
                    `Il modulo <b>${featureDescription}</b> è <b>incompatibile</b> con: <b>` +
                    incompatibilitiesList +
                    `</b>. Pertanto se vuoi selezionare questo modulo devi prima <b> deselezionare ` +
                    incompatibilitiesList +
                    '</b>';
            } else {
                popupBody +=
                    `The <b>${featureDescription}</b> module is <b>incompatible</b> with:<b> ` +
                    incompatibilitiesList +
                    `</b>, so if you want to add this module, you have to <b> deselect  ` +
                    incompatibilitiesList +
                    '</b>';
            }
        }
        if (popupBody.length > 0) this.workFlow.showMessage(this.variable.popupTitle, popupBody);
    }

    checkCompatibility(feature: Feature) {
        let dlgAsk;
        if (!feature.Incompatibilities) return true;
        let incompatibilities: string[] = feature.Incompatibilities.split(',').map((item: string) => item.trim());
        for (let i = 0; i <= incompatibilities.length; i++) {
            let index = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                (x) => x.fragment.toLowerCase() == incompatibilities[i].toLowerCase()
            );
            if (index > -1) {
                let descri = this.currentIndustry.Features.find(
                    (x) => x.Fragment.toLowerCase() == incompatibilities[i].toLowerCase()
                ).Description;

                let s: string = `il modulo selezionato è incompatibile con ${descri} , pertanto non è possibile selezionarlo`;
                dlgAsk = this.dialog.open(AlertDialogComponent, {
                    data: {
                        Title: 'this.variable.warningTitle',
                        Message: s,
                        Result: true,
                        ShowDisableMe: false,
                    },
                });
                dlgAsk.afterClosed().subscribe((resAskDlg) => {
                    if (resAskDlg === undefined) {
                        feature.isChecked = false;
                        feature.CurrNrOfUser = 0;
                    }
                });
                return false;
            } else return true;
        }
    }
    checkIfAllPrerequisiteAreChecked(prerequisites: string[]) {
        if (prerequisites.length == 0) return true;

        for (let i = 0; i < prerequisites.length; i++) {
            let fragment = prerequisites[i];

            let indexSelected = this.currIndustryPurchInfo.SelectedFeaturesOptionInfo.findIndex(
                (x) => x.fragment.toLowerCase() == fragment.toLowerCase()
            );
            let indexOpt = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                (x) => x.fragment.toLowerCase() == fragment.toLowerCase()
            );

            if (indexOpt == -1 && indexSelected == -1) return false;
            continue;
        }
        return true;
    }
    checkIfOneIncompatibilityIsChecked(incompatibilities: string[]) {
        if (incompatibilities.length == 0) return false;

        for (let i = 0; i < incompatibilities.length; i++) {
            let fragment = incompatibilities[i];

            let indexSelected = this.currIndustryPurchInfo.SelectedFeaturesOptionInfo.findIndex(
                (x) => x.fragment.toLowerCase() == fragment.toLowerCase()
            );
            let indexOpt = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex(
                (x) => x.fragment.toLowerCase() == fragment.toLowerCase()
            );
            if (indexOpt > -1 || indexSelected > -1) return true;
            continue;
        }
        return false;
    }
    public sortCALAscending() {
        this.CALFeature.sort((a, b) => {
            let aNr = parseInt(a.OptionID.substring(2, 4));
            let bNr = parseInt(b.OptionID.substring(2, 4));
            return bNr > aNr ? -1 : 1;
        });
    }
    public setCALFeature() {
        // this.CALFeature = [];
        this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.forEach((element) => {
            let plPrefix = element.optionID.substring(0, 2);
            if (plPrefix == CALPrefix.FL || plPrefix == CALPrefix.ED) {
                let plFeature = this.currIndustryPurchInfo.CountableFeatures.find((x) => x.OptionID == element.optionID);
                if (plFeature) {
                    plFeature.CurrNrOfUser = element.nrOfUser;
                    let index = this.CALFeature.findIndex((x) => x.OptionID == plFeature.OptionID);
                    if (index > -1) {
                        let plFeature = this.CALFeature[index];
                        plFeature.CurrNrOfUser = element.nrOfUser;
                    } else this.CALFeature.push(plFeature);
                    this.CALCountableFeatureSelected.push(plFeature);
                    this.setCalFullNr(plFeature);
                }
            }
        });
        this.sortCALAscending();
    }
    removeCALFromCountableFeature(features: Feature[]) {
        let purgedFeature = [];

        for (let i = 0; i < features.length; i++) {
            let f = features[i];
            if (!f.OptionID) continue;
            let plPrefix = f.OptionID.substring(0, 2);
            let plSuffix = f.OptionID.substring(2, f.OptionID.length);
            if ((plPrefix == CALPrefix.FL || plPrefix == CALPrefix.ED) && !isNaN(parseInt(plSuffix))) {
                if (this.CALFeature.findIndex((x) => x.Fragment == f.Fragment) == -1) this.CALFeature.push(f);
            } else purgedFeature.push(f);
        }

        return purgedFeature;
    }

    async loadPurhcInfo(filteredFeatureByCountry: Feature[], productRelease: string) {
        this.currIndustryPurchInfo.Version = this.currentIndustry.Versioning.toString();
        this.currIndustryPurchInfo.ModuleCode = this.currentIndustry.ModuleCode;
        this.currIndustryPurchInfo.TranslatedName = this.currentIndustry?.TranslatedName;
        this.currIndustryPurchInfo.Edition = this.currentIndustry.IndustryEditions.find((x) => x.EditionCode.toLowerCase() == this.edition);
        this.currIndustryPurchInfo.productID = this.currentIndustry.ProductID;
        this.currIndustryPurchInfo.db = 2; //postgress;
        this.currIndustryPurchInfo.Country = this.countryValue;
        let userAccountName = this.tbAuthService.getAccountName();
        this.currIndustryPurchInfo.gwamAccount = userAccountName;
        this.currIndustryPurchInfo.paymentModality = 0;
        this.currIndustryPurchInfo.priceRanges = this.currentIndustry.PriceRanges;
        this.currIndustryPurchInfo.MLUPriceRanges = this.currentIndustry.MLUPriceRanges;
        this.currIndustryPurchInfo.Customer = null;
        this.currIndustryPurchInfo.totalGrossAmount = 0;
        this.currIndustryPurchInfo.totalMLUAmount = 0;
        this.currIndustryPurchInfo.industryBaseAmount = 0;
        this.currIndustryPurchInfo.paymentPeriodicity = 1; //express in month
        this.currIndustryPurchInfo.cartRowID = '';
        let lang = this.workFlow.getLanguageForCms();
        await this.configurationService.getCalTypes(
            lang,
            this.currentIndustry.ModuleCode,
            this.edition.toLowerCase(),
            this.currentIndustry.Versioning.toString(),
            productRelease,
            this.storeRoleService.IsInternal ? '1' : '0',
            this.isModifyStatus ? '1' : '0',
            this.productID
        );

        let industryCal = this.configurationService.industry_Cal.find(
            (x) => x.industryCode == this.currIndustryPurchInfo.ModuleCode && x.editionCode == this.edition
        );
        this.currIndustryPurchInfo.caltypes = industryCal.caltypes == null || industryCal.caltypes.length == 0 ? [] : industryCal.caltypes;
        this.currentIndustry.Caltypes = this.currIndustryPurchInfo.caltypes;
        //
        var today = new Date();
        this.currIndustryPurchInfo.expirationDate = today.toISOString();
        this.currIndustryPurchInfo.SelectedFeatures = this.configurationService.getStandardFeature(
            filteredFeatureByCountry,
            this.currentIndustry,
            this.currIndustryPurchInfo,
            this.edition
        );
    }
    public disableButton() {
        return !this.currentIndustry || this.totalCalFullNr == 0;
    }

    public setCalFullNr(feature: Feature) {
        let currTotalCalFullNr = 0;
        let currQty = this.calFullNrMap.get(feature.OptionID); // ritorna la quantità
        if (!currQty) {
            //devo moltiplicare il currnrofuser per il numero della pl es se è una pl05 e
            //currnrofuser è 2 il totale deve dare 10
            let plSuffix = feature.OptionID.substring(2, feature.OptionID.length);
            let plNr = parseInt(plSuffix);
            if (isNaN(plNr)) return -1;
            else {
                let nr = plNr * feature.CurrNrOfUser;
                currTotalCalFullNr = currTotalCalFullNr + nr;
                this.calFullNrMap.set(feature.OptionID, nr);
            }
        } else {
            let plSuffix = feature.OptionID.substring(2, feature.OptionID.length);
            let plNr = parseInt(plSuffix);
            if (isNaN(plNr)) return -1;
            else {
                let nr = plNr * feature.CurrNrOfUser;
                currTotalCalFullNr = currQty + nr;
                this.calFullNrMap.set(feature.OptionID, nr);
            }
        }
        this.getTotalCalNr();
    }

    getTotalCalNr() {
        let totalQty: number = 0;
        for (let entry of this.calFullNrMap.entries()) {
            let pl = entry[0];
            let qty = entry[1];

            for (let i = 0; i < this.CALFeature.length; i++) {
                let calFeature = this.CALFeature[i];

                if (calFeature.OptionID == pl) {
                    totalQty = totalQty + qty;
                }
            }
        }
        this.totalCalFullNr = totalQty;

        if (!this.currIndustryPurchInfo.caltypes || this.currIndustryPurchInfo.caltypes.length == 0) return;
        let callFullObj = this.currIndustryPurchInfo.caltypes.find((x) => x.CalType == 1);
        callFullObj.NrCalBuyed = this.totalCalFullNr; //devo trasformarlo in n
    }
    public async createOrUpdateTestSubscription(accountName: string) {
        if (this.currIndustryPurchInfo.Country || this.currIndustryPurchInfo.Country.length == 0)
            this.currIndustryPurchInfo.Country = this.countryValue;
        //aggiungo le PL alle countable
        this.CALCountableFeatureSelected.forEach((element) => {
            let exists = this.currIndustryPurchInfo.CountableFeatures.findIndex((x) => x.OptionID == element.OptionID) > -1;
            if (!exists) this.currIndustryPurchInfo.CountableFeatures.push(element);
        });

        this.selectedOptionInfo.forEach((element) => {
            let exists = this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.findIndex((x) => x.optionID == element.optionID) > -1;
            if (!exists) this.currIndustryPurchInfo.OptionalFeaturesOptionInfo.push(element);
        });

        //qui ci metto l'eventuale instancekey selezionatata nelle opzioni
        this.currIndustryPurchInfo.instanceKey = this.instanceKey;
        this.currIndustryPurchInfo.SnapshotID = this.selectedSnapshotID;
        this.currCompanyCode = '0110G081';
        //piuttosto che non metterci nulla nelle variabili ci metto il codice azienza
        if (this.currIndustryPurchInfo.SubscriptionKey.length == 0) {
            return await this.subscriptionService.createTestSubscription(
                this.currIndustryPurchInfo,
                this.subTypeSelected,
                '2', //default value
                this.instanceKey,
                accountName,
                '',
                this.storeRoleService.IsInternal ? '1' : '0',
                this.isModifyStatus ? '1' : '0',
                this.productService.instanceVersionInfo,
                this.selectedSnapshotID
            );
        }
        if (this.currIndustryPurchInfo.SubscriptionKey.length != 0) {
            let subInfo = await this.subscriptionService.getSubscriptionsToPromise(accountName, this.currIndustryPurchInfo.SubscriptionKey);
            let subscriptions = subInfo['Content'];
            let subscription: AppSubscription = subscriptions[0];
            return await this.subscriptionService.updateTestSubscription(
                this.currIndustryPurchInfo,
                this.subTypeSelected,
                '2', //default value
                this.instanceKey,
                subInfo,
                accountName,
                this.storeRoleService.IsInternal ? '1' : '0',
                this.isModifyStatus ? '1' : '0',
                this.productService.instanceVersionInfo
            );
        }
    }
    public addElementApplication() {
        let applicationList: string[] = [];

        for (let i = 0; i < this.currIndustryPurchInfo.OptionalFeatures.length; i++) {
            let element = this.currIndustryPurchInfo.OptionalFeatures[i];

            let optionInfo = element.Options.find(
                (x) => x.availability.toLowerCase() == OptionAvailability.COUNT && x.edition.toLowerCase() == this.edition.toLowerCase()
            );
            if (optionInfo) continue;

            let graphElement: GraphElement = this.graphElements.find((x) => x.Fragment.toLowerCase() == element.Fragment.toLowerCase());
            if (!graphElement) return;

            for (let i = 0; i < graphElement.Applications.length; i++) {
                let app = graphElement.Applications[i];
                if (applicationList.includes(app, 0)) continue;
                applicationList.push(app);
            }
        }
        return applicationList;
    }

    getAppList(applicationList: string[]) {
        var output: string = '';
        if (!applicationList) return output;

        for (let i = 0; i < applicationList.length; i++) {
            let app = applicationList[i];
            if (i == 0) output = app;
            else {
                output = output + ',' + app;
            }
        }
        return output;
    }

    public Clear() {
        this.language = '';
        this.industryDictionaryList = []; //usato nell'html
        this.loading = true;
        this.countryValue = 'none';
        this.isModifyStatus = false;
        this.countryDescri = '';
        this.currIndustryPurchInfo = new IndustryPurchasedInfo();
        this.moduleCode = '';
        this.version = '';
        this.edition = '';
        this.currentIndustry = new IndustryDescription();
        this.filteredFeatureByCountry = [];
        this.CALFeature = [];
        this.functionalitygroupsNoCAL = [];
        this.functionalitygroupsAlwaysAvalilable = [];
        this.functionalitygroupsCAL = [];
        this.CALCountableFeatureSelected = [];
        this.selectedOptionInfo = [];
        this.calFullNrMap = new Map<string, number>();
        this.totalCalFullNr = 0;
        this.currCompanyCode = '';
        this.currCompanyName = '';
        this.tempGraphElement = [];
        this.graphElements = [];
        this.subscriptionNfs = false;
        this.isZucchettiDiretta = false;
        this.isAllowedToChooseMultiInstances = false;
        this.instanceKey = '';
    }
}
